// settings strings (en). Filled by i18n extraction.
const settings = {
	settings: {
		// Settings sidebar nav
		nav_yourProfile: 'Your Profile',
		nav_billing: 'Billing',
		nav_generateZapierKey: 'Generate Zapier key',
		nav_generateIntegrationKey: 'Generate Integration Key',
		nav_mcp: 'AI Assistants (MCP)',
		nav_referEarn: 'Refer & Earn',
		nav_manageWorkspaces: 'Manage Workspaces',
		nav_emailAccounts: 'Email Accounts',
		nav_basicSettings: 'Basic Settings',
		nav_teamMembers: 'Team Members',
		nav_previewCard: 'Preview Card',
		nav_lastPage: 'Default Last Page',

		// Default last page
		lastPage_title: 'Default last page',
		lastPage_desc: 'Add a page with your logo, address, website or a call to action to the end of every card in this workspace.',
		lastPage_enable: 'Add to every card',
		lastPage_enableDesc: 'When on, this page is shown as the last page of all cards in this workspace, including cards already sent.',
		lastPage_onlyAdmins: 'Only the workspace owner or a workspace manager can change this page.',
		lastPage_preview: 'Page preview',
		lastPage_edit: 'Edit page',
		lastPage_empty: 'This page is empty. Click "Edit page" to design it.',
		lastPage_editorTitle: 'Default last page',
		lastPage_editorHint: 'This page is added to the end of every card in this workspace. It is the same for every recipient.',
		lastPage_back: 'Back to settings',
		lastPage_done: 'Done',
		lastPage_saving: 'Saving…',
		lastPage_saved: 'Saved',
		lastPage_saveFailed: 'Could not save',
		lastPage_loadFailed: 'Could not load the last page. Please try again.',
		nav_workspaceDomain: 'Workspace Domain',
		nav_videoCards: 'Video Cards',
		nav_customDomainSettings: 'Custom Domain Settings',
		nav_personalization: 'Personalization',
		section_accountSettings: 'Account Settings',
		section_workspaceSettings: 'Workspace Settings',
		section_whiteLabelSettings: 'White Label Settings',

		// Shared dialog titles / statuses
		title_success: 'Success',
		title_error: 'Error',
		title_oops: 'Oops!',
		title_warning: 'Warning',
		title_sorry: 'Sorry',
		uploading: 'Uploading...',

		// Basic Settings
		basicDetailsTitle: 'Basic Details',
		workspaceImageUpdated: 'Workspace image is updated.',
		workspaceName: 'Workspace Name',
		timeZone: 'Time-Zone',
		saveUpdate: 'Save & Update',
		noWorkspace: "Currently you don't have any workspace",
		nothingToUpdate: 'Nothing to update.',
		changesSaved: 'Your changes have been saved successfully',
		somethingWrongSaving: 'Something went wrong while your changes were being saved.',

		// Custom Domain Settings
		domainTitle: 'Domain',
		addCustomDomain: 'Add your custom domain',
		whiteLabelRunDesc: 'This is where your white labeled app will run',
		howToSetupWhiteLabel: 'How to setup your white label domain?',
		domainName: 'Domain Name',
		domainPlaceholder: 'app.example.io',
		saveDomain: 'Save Domain',
		cnameInstructions:
			"In order to map a custom domain to your support portal, make sure that you've added the following CNAME record in your DNS zone editor settings. Your Webmaster or Server administrator should be able to help you set this up.",
		tableType: 'Type',
		tableKey: 'Key',
		tableValue: 'Value',
		tableSslStatus: 'SSL status',
		tableConnectionStatus: 'Connection status',
		statusActive: 'active',
		statusInactive: 'inactive',
		copy: 'copy',
		cannotSaveHostDomain: 'Cannot save host domains as a white Label Domain',

		// Manage Workspaces
		workspacesTitle: 'Workspaces',
		addNewWorkspace: 'Add new workspace',
		searchWorkspaces: 'Search Workspaces',
		howToAddWorkspaces: 'How to add new workspaces to your account?',
		noWorkspacesToShow: 'No workspaces to show.',
		maxLimitReached: 'Maximum limit reached',
		maxWorkspaceLimit: 'You have reached the maximum limit for your workspaces for this plan',
		problemGettingWorkspaces: 'Encountered a problem while getting your workspaces',

		// Invite member (workspace flow)
		inviteMemberTitle: 'Invite member',
		workspaceDetails: 'Workspace details',
		inviteTeamMembers: 'Invite Team Members',
		inviteTeamMembersStep: 'Invite Team members',
		addMoreMembersLater: 'You can always add more team members later from the workspace settings.',

		// New workspace detail
		newWorkspace: 'New Workspace',
		howToAddWorkspacesAccount: 'How to add new workspaces to your account.',
		workspaceNamePlaceholder: 'Your workspace name',
		saveNext: 'Save & Next',

		// Workspace card
		selected: 'selected',
		createdOn: 'Created on:',
		remove: 'Remove',
		removeWorkspaceConfirm: 'Are you sure you want to remove the workspace ?',
		cannotDeleteCurrent:
			'Cannot delete the selected workspace, Switch to a different workspace and then remove it.',

		// Profile / Account
		accountTitle: 'Account',
		deleteAccount: 'Delete Account',
		deleteAccountDesc:
			'Deleting your account will delete your access and all your information on this site. Are you sure you want to continue?',
		updatedProfileSuccess: 'Successfully updated profile',
		accountDeletionTitle: 'Account Deletion',
		deleteAccountConfirm: 'Do you want to delete your account?',
		btnNo: 'No',
		btnYes: 'Yes',
		accountDeletedTitle: 'Account Deleted',
		accountDeletedText: 'Your account is deleted successfully.',
		accountDeletionRelogin:
			'If you want to delete your account. Please login again and then delete your account.',

		// Basic profile fields
		firstName: 'First Name',
		lastName: 'Last Name',
		email: 'Email',
		emailCannotChange: "Email can't be changed",

		// Change password
		currentPassword: 'Current Password',
		invalidPassword: 'Invalid password',
		newPassCannotSame: 'New password cannot be same',
		confirmPassMismatch: "Confirm password doesn't match",

		// Team members
		membersTitle: 'Members',
		inviteMemberBtn: 'Invite a member',
		howToInviteMember: 'How to invite a team member to your workspace?',
		noTeamMembers: 'There are currently no team members in this workspace.',
		errorDeletingMember: 'Error occurred while deleting member',
		deleteMemberConfirm: 'Are you sure, you want to delete member ?',
		invitationLinkGenerated: 'Invitation link has been generated for %{email}',
		invitationLinkSent: 'Invitation link has been sent to %{email}',
		maxMembersReached: 'You have reached maximum members for your plan',

		// Members card
		searchByNameEmail: 'Search by name and email',
		inviteLinkCopied: 'Invite link copied.',
		noSearchResults: 'No search results found.',

		// Members table
		colName: 'Name',
		colRole: 'Role',
		colStatus: 'Status',
		colActions: 'Actions',
		roleManager: 'Manager',
		roleMember: 'Member',
		roleNotFound: 'Role not Found',
		tooltipEditRole: 'Edit Role',
		tooltipDeleteMember: 'Delete Team member',
		tooltipCopyInviteLink: 'Copy Invite Link.',

		// Invite member modal
		howToInviteWorkspace: 'How to invite team member in workspace?',
		placeholderFirstName: 'john',
		placeholderLastName: 'doe',
		placeholderEmailExample: 'johndoe@example.com',
		sendInvitation: 'Send Invitation',
		ownerCannotInvite: 'Owner cannot invite theirself to the workspace.',
		memberEmailExists: 'A member with this email already exists.',

		// Referral
		referAndEarn: 'Refer and Earn',
		earnCommission: 'Earn 30% Recurring Commissions!',
		howItWorks: "Here's how our affiliate program works:",
		step1Join: '1. Join',
		step2Refer: '2. Refer',
		step3Earn: '3. Earn',
		joinDesc: 'Sign up for the CardClan affiliate program.',
		referDesc: 'Share your unique affiliate link with your friends and followers.',
		earnDesc: 'Receive 30% commission on every sale we get from your affiliate link.',
		noteLabel: 'Note: ',
		noteText:
			"It's not just that one payment when they sign up. That 30% commission will be paid to you every month for as long as their CardClan acount is active.",
		becomeAffiliate: 'Become an affiliate',
		createPromoter: 'Create Promoter',
		registerAffiliateDesc: 'Use below link to register yourself as CardClan affliate to start promoting.',
		createPromoterLink: 'Create promoter',

		// Dropdown
		options: 'Options',

		// AI Assistants (MCP)
		mcp_title: 'AI Assistants (MCP)',
		mcp_description: 'Connect Claude, Cursor, VS Code or any MCP-compatible assistant to CardClan. Your assistant can then find cards, send or schedule them to recipients, organize folders and report on engagement — using your account and plan limits.',
		mcp_keyTitle: 'Your API key',
		mcp_keyDescription: 'The assistant authenticates with your CardClan API key (the same key used for integrations).',
		mcp_keyWarning: 'Anyone with this key can send cards from your account. Keep it secret and never paste it into shared documents.',
		mcp_generateKey: 'Generate API key',
		mcp_show: 'Show',
		mcp_hide: 'Hide',
		mcp_copy: 'Copy',
		mcp_copied: 'Copied to clipboard',
		mcp_urlTitle: 'Server URL',
		mcp_urlDescription: 'The CardClan MCP endpoint (Streamable HTTP).',
		mcp_setupTitle: 'Add CardClan to your assistant',
		mcp_setupDescription: 'Pick your client and copy the configuration. The copied text includes your full API key.',
		mcp_clientOther: 'Other clients',
		mcp_hint_claudeCode: 'Run this command in your terminal.',
		mcp_hint_claudeDesktop: 'Open Settings → Developer → Edit Config and merge this into claude_desktop_config.json, then restart Claude Desktop. Requires Node.js.',
		mcp_hint_cursor: 'Add this to ~/.cursor/mcp.json (or .cursor/mcp.json in a project).',
		mcp_hint_vscode: 'Add this to .vscode/mcp.json in your workspace, or run “MCP: Add Server” from the command palette.',
		mcp_hint_other: 'Any client that supports remote MCP servers over Streamable HTTP with a custom header will work.',
		mcp_tryPrompt: 'Try asking: “List my CardClan cards and send the holiday card to ann@example.com tomorrow at 9am.” Your assistant will preview the send and ask before emailing anyone.',
		mcp_toolsTitle: 'What your assistant can do',
		mcp_toolsDescription: 'Tools marked “Can make changes” update your account or send email; most assistants ask for your approval before using them.',
		mcp_readOnly: 'Read-only',
		mcp_makesChanges: 'Can make changes',
		mcp_activityTitle: 'Recent activity',
		mcp_activityDescription: 'Every action taken through MCP with your API key. Kept for 90 days.',
		mcp_activityTotal: '%{count} actions in the last 90 days',
		mcp_activityEmpty: 'No activity yet. Once your assistant is connected, its actions will appear here.',
		mcp_activityLoadFailed: 'Could not load MCP activity.',
		mcp_refresh: 'Refresh',
		mcp_loadMore: 'Load more',
		mcp_colTime: 'Time',
		mcp_colTool: 'Action',
		mcp_colResult: 'Result',
		mcp_colDuration: 'Duration',
		mcp_success: 'Success',
		mcp_failed: 'Failed',
	} as Record<string, string>,
};
export default settings;
